import { styled } from '@mui/material';
import { useMemo } from 'react';

import type { ITimeframe } from '../../../../../core/types/dateTypes';
import { FrontSelect } from '../../../../../ui-components';

export const timeframeIntervalOptions: {
  value: ITimeframe;
  label: string;
}[] = [
  { value: 'daily', label: 'Daily' },
  { value: 'wow', label: 'Weekly' },
  { value: 'mom', label: 'Monthly' },
  { value: 'quarter', label: 'Quarterly' },
  { value: 'annual', label: 'Yearly' },
];

interface IProps {
  timeframe: ITimeframe;
  onChange: (timeframe: ITimeframe) => void;
}

export const TimeInterval = ({ timeframe, onChange }: IProps) => {
  const value = useMemo(
    () => timeframeIntervalOptions.find((option) => option.value === timeframe),
    [timeframe],
  );
  return (
    <Wrapper>
      <FrontSelect
        size={'small'}
        width={'220px'}
        minWidth={'220px'}
        placeholder="Select Interval"
        defaultValue={value}
        value={value}
        options={timeframeIntervalOptions}
        name="timeframeIntervalSelect"
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        onChange={(e) => e && onChange(e.value)}
        isMulti={false}
        isSearchable={false}
        isLoading={false}
        noOptionsMessage={() => 'No Interval Available'}
      />
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  margin-top: 8px;
`;
